"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const tab_style_1 = __importDefault(require("./tab.style"));
const Tab = ({ classes, uniqueKey, activeTab, label, onClick, folder, prefix }) => {
    const handleClick = event => onClick(event, uniqueKey);
    const rootProps = {
        className: classes.root,
        'data-is-active': activeTab === uniqueKey,
        'data-has-folder': folder,
        onClick: handleClick
    };
    return (jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx("span", { children: prefix }, void 0), label] }), void 0));
};
exports.Tab = Tab;
exports.Tab.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    uniqueKey: prop_types_1.default.string.isRequired,
    activeTab: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    folder: prop_types_1.default.bool,
    prefix: prop_types_1.default.node
};
exports.Tab.defaultProps = {
    folder: false,
    prefix: ''
};
exports.default = react_jss_1.default(tab_style_1.default)(exports.Tab);
//# sourceMappingURL=index.js.map